var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vuDropdown",
      class: _vm.classes,
      attrs: { id: _vm.p.id },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.hasTrigger
        ? _c(
            "div",
            { ref: "trigger", staticClass: "vuDropdown__trigger" },
            [_vm._t("trigger")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "body",
          staticClass: "vuDropdown__body",
          attrs: {
            role: _vm.p.asListBox ? "listbox" : "menu",
            "aria-labelledby": _vm.p.triggerId === "" ? null : _vm.p.triggerId,
            tabindex: "-1",
          },
        },
        [
          _vm.p.withArrow
            ? _c("div", {
                staticClass: "vuDropdown__arrow",
                attrs: { tabindex: "-1", "data-popper-arrow": "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("beforeItems"),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "vuDropdown__items" },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm._t("afterItems"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }